import React from "react";
import { Tab, Tabs } from "react-bootstrap";

import EnquiriesTab from '../components/callback/EnquiriesTab';
import HistoryTab from '../components/callback/HistoryTab';

let Callbacks = class extends React.Component {
    render() {
        return (
            <Tabs defaultActiveKey='enquiries' id='callback-tabs' unmountOnExit={true}>
                <Tab eventKey='enquiries' title='Новые заявки'>
                    <EnquiriesTab />
                </Tab>
                <Tab eventKey='history' title='Обработанные заявки'>
                    <HistoryTab />
                </Tab>
            </Tabs>
        );
    }
}

export default Callbacks;


// WEBPACK FOOTER //
// ./src/containers/Callbacks.jsx